import AddIPSecSegment from "../../../modules/custom/addVPN/IPSEcSegment";
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const AddIpsecGMENTS: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Validación de permisos y redirección con retraso
  useEffect(() => {
    const delay = setTimeout(() => {
      // Asegurarse de que los permisos estén cargados
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Cambiar estado cuando los permisos estén cargados
        if (
          !ListaPermisosTenant.includes('Ctx.IPSEC.List') &&
          !ListaPermisosTenant.includes('Ctx.IPSEC.Add') &&
          !ListaPermisosTenant.includes('Ctx.IPSEC.Delete')
        ) {
          // Si no tiene permisos de IPSec, validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else if (ListaPermisosTenant.includes('CC.View')) {
            // Si tiene permiso CC.View, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          } else {
            // Si no tiene ninguno de los permisos anteriores, redirigimos a auth/*
            navigate('/auth/*');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo (1000 ms)

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Mostrar un mensaje de carga mientras se obtienen los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>
          Estamos validando tus permisos...
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='card mb-5 mb-xl-5'>
        <AddIPSecSegment />
      </div>
    </>
  );
}

export { AddIpsecGMENTS };
